import React from "react";
import {
  Container,
  FormControl,
  Paper,
  TextField,
  Typography
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../app/hooks'
import {
  setAktuellerWert,
  selectAktuellerWert
} from "./wertelisteSlice";

import { useStyles } from "./wertelisteStyles";
import { Autocomplete } from "@material-ui/lab";
import { globalStyles } from "../../../assets/globalStyles";
import { werte } from "./wertelisteTypes";
import { Messgeraettypen } from "./messgeraettypen/Messgeraettypen";
import { Routergeraettypen } from "./routergeraettypen/Routergeraettypen";
import { Schaltfelder } from "./schaltfelder/Schaltfelder";
import { Spannungsebenen } from "./spannungsebenen/Spannungsebenen";
import { Umspannwerke } from "./umspannwerke/Umspannwerke";
import { Spannungswandler } from "./spannungswandler/Spannungswandler";
import Grid from "@material-ui/core/Grid";
import Wandler from "./wandler/Wandler";
import Wartungsintervall from "./wartungsintervall/Wartungsintervall";
import Zeitsynchronisationsart from "./zeitsynchronisationsart/Zeitsynchronisationsart";
import { Anlagen } from "./anlagen/Anlagen";

export const Wertelisten: React.FC = () => {
  const dispatch = useAppDispatch();

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const werteliste = [
    { title: 'Umspannwerk' },
    { title: 'Schaltfeld' },
    { title: 'Spannungsebene' },
    { title: 'Wandlerfaktor Strom' },
    { title: 'Wandlerfaktor Spannung' },
    { title: 'Messgerättyp' },
    { title: 'Routertyp' },
    { title: 'Wartungsintervall' },
    { title: 'Zeitsynchronisationsart' },
    { title: 'Angeschlossene Anlagen' }
  ]
  const aktuellerWert: werte = useAppSelector(selectAktuellerWert);

  function printWerteliste() {
    return (
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid item md={3} >
          <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
            Werteliste Auswahl
          </Typography>
        </Grid>
        <FormControl className={classes.fullWidth} >
          <Autocomplete
            id="select-werte"
            noOptionsText={"Keine Werteliste"}
            value={aktuellerWert.wertname}
            onChange={(_, newValue) => {
              if (newValue) dispatch(setAktuellerWert(newValue));
            }}
            inputValue={aktuellerWertSelectInputValue}
            onInputChange={(event, newInputValue) => {
              setAktuellerWertSelectInputValue(newInputValue);
            }}
            options={werteliste.map(wert => wert.title)}
            renderInput={(params) => <TextField {...params} label="Werteliste" variant="outlined" />}
            className={classes.selectEmpty}
            style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "20px" }}
          />
        </FormControl>
      </Paper>
    );
  }

  const [aktuellerWertSelectInputValue, setAktuellerWertSelectInputValue] = React.useState('');

  return (
    <div>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Administration Werte
            </Typography>
          </Grid>
        </Grid>
      </Container>
      {printWerteliste()}
      {aktuellerWert.wertname == "Messgerättyp" ? <Messgeraettypen></Messgeraettypen> : null}
      {aktuellerWert.wertname == "Routertyp" ? <Routergeraettypen></Routergeraettypen> : null}
      {aktuellerWert.wertname == "Schaltfeld" ? <Schaltfelder></Schaltfelder> : null}
      {aktuellerWert.wertname == "Spannungsebene" ? <Spannungsebenen></Spannungsebenen> : null}
      {aktuellerWert.wertname == "Umspannwerk" ? <Umspannwerke></Umspannwerke> : null}
      {aktuellerWert.wertname == "Wandlerfaktor Spannung" ? <Spannungswandler></Spannungswandler> : null}
      {aktuellerWert.wertname == "Wandlerfaktor Strom" ? <Wandler wandlerTyp="Strom" getUrl={"STROMWANDLER"} createUrl={"STROMWANDLERID"} updateUrl={"STROMWANDLERID"} deleteUrl={"STROMWANDLERID"}></Wandler> : null}
      {aktuellerWert.wertname == "Wartungsintervall" ? <Wartungsintervall typ="Wartungsintervall" getUrl={"WARTUNGSINTERVALL"} createUrl={"WARTUNGSINTERVALLID"} updateUrl={"WARTUNGSINTERVALLID"} deleteUrl={"WARTUNGSINTERVALLID"}></Wartungsintervall> : null}
      {aktuellerWert.wertname == "Zeitsynchronisationsart" ? <Zeitsynchronisationsart typ="Zeitsynchronisationsart" getUrl={"ZEITSYNCHRONISATIONSART"} createUrl={"ZEITSYNCHRONISATIONSARTID"} updateUrl={"ZEITSYNCHRONISATIONSARTID"} deleteUrl={"ZEITSYNCHRONISATIONSARTID"}></Zeitsynchronisationsart> : null}
      {aktuellerWert.wertname == "Angeschlossene Anlagen" ? <Anlagen></Anlagen> : null}
    </div>
  );
}
